import Link from 'next/link'
import { usePathname } from 'next/navigation'
import { UserStarIcon } from 'lucide-react'

import { Button } from '@/components/ui/button'
import { signUpHref } from '@/constants/authRoutes'

/** Compact login prompt for tooltip when user is not logged in. */
export const TrackTagLoginPrompt = () => {
  const pathname = usePathname()

  return (
    <div className="flex max-w-50 flex-col items-center gap-2 py-1 text-center text-balance">
      <div className="flex size-8 items-center justify-center rounded-lg bg-evergreen-100 p-1.5">
        <UserStarIcon className="size-4 text-evergreen-800" />
      </div>
      <p className="text-xs font-semibold text-foreground">
        Sign up or sign in to track this bill.
      </p>
      <div className="flex flex-wrap items-center justify-center gap-1.5">
        <Button variant="accent" size="small" className="shrink-0 whitespace-nowrap" asChild>
          <Link href={signUpHref(pathname)} onClick={(e) => e.stopPropagation()}>
            Sign up
          </Link>
        </Button>
        <Button variant="outline" size="small" className="shrink-0 whitespace-nowrap" asChild>
          <Link href={`/sign-in?redirectTo=${pathname}`} onClick={(e) => e.stopPropagation()}>
            Sign in
          </Link>
        </Button>
      </div>
    </div>
  )
}
